import React from 'react'
import styled from 'styled-components'
import InputTC from '../../../components/input-tc/input-tc'
import { User } from '@styled-icons/boxicons-regular'
import { LockPassword } from '@styled-icons/remix-line'
import logo from '../../../assets/img/logo.png'
import tLogo from '../../../assets/img/t-logo.png'
import bus from '../../../assets/img/bus-footer.png'
import ButtonTC from '../../../components/button-tc/button-tc'
import { NavLink } from 'react-router-dom'
import { device } from '../../../config/theme/breakpoints'

const WrapperPage = styled.div`
    position: relative;
    width: 100%;
    height: 100vh;
    min-height: fit-content;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
`
const ContainerLogin = styled.div`
    max-width: 400px;
    width: 100%;
    padding: 15px;
`

const ContainerTitle = styled.div`
    text-align: center;
    
    > img {
        max-width: 120px;
    }

    > h1 {
        margin-top: 10px;
        margin-bottom: 30px;
        color: #757575;
    }
`
const ContainerForm = styled.div`
    > div a {
        margin-top: 6px;
        text-decoration: none;
        color: #757575;
    }
`

const ContainerButtons = styled.div`
    padding-top: 40px;
    padding-bottom: 20px;
`

const TLogoImage = styled.img`
    position: absolute;
    top: -30px;
    left: -120px;
    max-width: 350px;
`
const BusLogoImage = styled.img`
    position: absolute;
    bottom: -30px;
    right: 0;
    max-width: 200px;
    display: none;

    @media ${device.tablet}{
        display: block;
    }
`

const RectangleDesign = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    height: 50px;
    width: 80%;
    background: linear-gradient(90deg, rgba(225,48,40,1) 0%, rgba(254,165,0,1) 100%);
    clip-path: polygon(0 0, 0% 100%, 100% 100%);
`

const CustomButton = `
    width: inherit;
    margin-top: 10px;
`

const Login: React.FC = () => {
  return (
    <WrapperPage>
        <TLogoImage src={tLogo} alt='Logo'/>
        <BusLogoImage src={bus} alt='Logo'/>
        <RectangleDesign />
        <ContainerLogin>
            <ContainerTitle>
                <img src={logo} alt='Logo'/>
                <h1>Iniciar Sesión</h1>
            </ContainerTitle>
            <ContainerForm>
                <div><InputTC type="text" textHolder='Usuario' icon={<User />}/></div>
                <div><InputTC type="password" textHolder='Contraseña' icon={<LockPassword />}/></div>
                <div><NavLink to='/'>¿Olvidaste tu contaseña?</NavLink></div>
            </ContainerForm>
            <ContainerButtons>
            <ButtonTC
                  text='Iniciar Sesión'
                  className={CustomButton}
                  buttonStyle='primary'
                  onClick={() => console.log}
                />
                <ButtonTC
                  text='Registrarse'
                  className={CustomButton}
                  buttonStyle='secondary'
                  onClick={() => console.log}
                />
            </ContainerButtons>
        </ContainerLogin>
    </WrapperPage>
  )
}

export default Login